// chat state (relates to viewing chat in the sidebar for your current space/room)
// documentation link tbc

const state = {
  ifLoadingChat: false,
  ifLoadingMoreChatMessages: false,
  currentChatMessages: [],

  // event switch for adding live messages and scroll to bottom
  ifScrollToBottomOfChat: false,
  noMoreMessages: false,
  newChatWaiting: false
};

const getters = {
  getIfLoadingChat: (state) => {
    return state.ifLoadingChat
  },
  getIfLoadingMoreChatMessages: (state) => {
    return state.ifLoadingMoreChatMessages
  },
  // current chat channel info
  getChatLocation: (state, getters) => {
    return getters.getCurrentLocationData
  },
  getCurrentChatId: (state,getters) => {
    return getters.getChatLocation.id
  },
  getCurrentChatTitle: (state,getters) => {
    return getters.getChatLocation.name
  },
  getCurrentChatMessages: (state) => {
    return state.currentChatMessages || []
    // return state.getters.getCurrentChatData?.messages || []
  },

  // event switch for adding live messages and scroll to bottom
  getIfScrollToBottomOfChat: (state) => state.ifScrollToBottomOfChat,

  getNoMoreMessages: (state) => state.noMoreMessages,
  getNewChatWaiting: (state) => state.newChatWaiting,
};

const mutations = {
  setIfLoadingChat(state, data) {
    state.ifLoadingChat = data
  },
  setIfLoadingMoreChatMessages(state, data) {
    state.ifLoadingMoreChatMessages = data
  },
  setCurrentChatMessages(state, data) {
    state.currentChatMessages = data
  },

  // event switch for adding live messages and scroll to bottom
  setIfScrollToBottomOfChat(state, data) {
    state.ifScrollToBottomOfChat = data
  },

  setNoMoreMessages(state, data) {
    state.noMoreMessages = data
  },

  setNewChatWaiting(state, data) {
    state.newChatWaiting = data
  }
};

const actions = {
  async updateCurrentChatMessages({commit}, data) {
    commit('setCurrentChatMessages', data)
  },
  async addToTopOfCurrentChatMessages({getters,commit}, data) {
    commit('setCurrentChatMessages', [...data,...getters.getCurrentChatMessages ])
  },
  async addToBottomOfCurrentChatMessages({getters,commit}, data) {
    commit('setCurrentChatMessages', [...getters.getCurrentChatMessages,...data ])
  },
  async clearChatMessages({commit}) {
    commit('setCurrentChatMessages', [])
    commit('setNoMoreMessages', false)
    commit('setIfLoadingChat', false)
    commit('setIfLoadingMoreChatMessages', false)
  },
  //fetch chat data
  async loadChatHandler({getters, commit, dispatch}, data) {
    commit('setIfLoadingChat', true)
    if(!getters.getIfLoadingChat) return
    let res = await dispatch('api/chat/getMessageHistory', data)
    commit('setIfLoadingChat', false)
    dispatch('loadChatCallback', res)
    return res
  },
  async loadChatCallback({dispatch}, res) {
    if(res.success) {
      let data = res.success
      await dispatch('updateCurrentChatMessages', data.messages)
      // dispatch('updateCurrentChatData', data)
    } else {
      await dispatch('updateCurrentChatMessages', [])
      // we don't show the error popup because it might just be a room guest trying to load area chat
      // TODO: need a better way of handling this
      // dispatch('popups/show/error/custom', 'loading chat')
      console.error(res)
    }
  },

  // load more chat messages
  async loadMoreChatMessagesHandler({getters, commit, dispatch},data) {
    if(
      getters.getIfLoadingChat ||
      getters.getNoMoreMessages ||
      getters.getIfLoadingMoreChatMessages
    ) return

    commit('setIfLoadingMoreChatMessages', true)
    let res = await dispatch('api/chat/getMessageHistory', data)
    //add timeout after x seconds so doesn't load forever?
    commit('setIfLoadingMoreChatMessages', false)
    dispatch('loadMoreChatMessagesCallback', res)
    return res
  },
  async loadMoreChatMessagesCallback({dispatch, commit}, res) {
    if(!res.success) {
      dispatch('popups/show/error/custom', 'loading chat history')
      console.error(res)
    }
    else {
      let { messages } = res.success

      if(!messages.length) commit('setNoMoreMessages', true)
      else dispatch('addToTopOfCurrentChatMessages', messages)
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};
